import React, { useState } from "react";
import { Tree, Table } from "antd";
import "antd/dist/reset.css";

// Simulate tree structure
const treeData = [
  {
    title: "Commercial",
    key: "commercial",
    children: [
      {
        title: "Billing",
        key: "billing",
        children: [
          { title: "Nakuru water", key: "nakuru-billing", isLeaf: true },
        ],
      },
    ],
  },
  {
    title: "Technical",
    key: "technical",
    children: [
      {
        title: "Abstraction Production",
        key: "abstraction",
        children: [
          { title: "Nakuru water", key: "nakuru-abs-1", isLeaf: true },
          { title: "Nakuru water", key: "nakuru-abs-2", isLeaf: true },
        ],
      },
    ],
  },
];


const reportMap = {
  "nakuru-billing": {
    columns: [
      { title: "Customer", dataIndex: "customer", key: "customer" },
      { title: "Amount", dataIndex: "amount", key: "amount" },
    ],
    data: [
      { key: "1", customer: "John Doe", amount: "Ksh 1,200" },
      { key: "2", customer: "Jane Smith", amount: "Ksh 800" },
    ],
  },
  "nakuru-abs-1": {
    columns: [
      { title: "Station", dataIndex: "station", key: "station" },
      { title: "Litres Produced", dataIndex: "litres", key: "litres" },
    ],
    data: [
      { key: "1", station: "Intake A", litres: "12,000L" },
      { key: "2", station: "Intake B", litres: "9,500L" },
    ],
  },
  "nakuru-abs-2": {
    columns: [
      { title: "Zone", dataIndex: "zone", key: "zone" },
      { title: "Pressure", dataIndex: "pressure", key: "pressure" },
    ],
    data: [
      { key: "1", zone: "North", pressure: "2.5 bar" },
      { key: "2", zone: "South", pressure: "2.0 bar" },
    ],
  },
};

const DynamicTreeAndTable = () => {
  const [expandedKeys, setExpandedKeys] = useState(["commercial", "technical"]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);

  const onSelect = (keys, { node }) => {
    setSelectedKeys(keys);

    if (node.isLeaf && reportMap[node.key]) {
      const report = reportMap[node.key];
      setTableColumns(report.columns);
      setTableData(report.data);
    } else {
      setTableColumns([]);
      setTableData([]);
    }
  };

  return (
    <div className="flex lg:flex-row flex-col w-full gap-[1rem]"> 
      <div className="bg-white px-[1.5rem] py-[2.25rem] dataset-card min-h-[60vh] ">
        <Tree
          showLine={{ showLeafIcon: false }}
          expandedKeys={expandedKeys}
          onExpand={setExpandedKeys}
          selectedKeys={selectedKeys}
          onSelect={onSelect}
          treeData={treeData}
        />
      </div>

     
      <div className="  w-full bg-white p-[2.25rem]   dataset-card min-h-[60vh]">
        <Table
          columns={tableColumns}
          dataSource={tableData}
          pagination={false}
          bordered
        />
      </div>
    </div>
  );
};

export default DynamicTreeAndTable;
